import React, { useState, useEffect } from "react";
import { db } from "../../../firebase/config";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { useAuth } from "../../../context/AuthContext";
import { useTheme } from "../../../context/ThemeContext";
import Header from "../../../components/Header";

export default function GestionPortal() {
  const { clinicaId } = useAuth();
  const { theme } = useTheme();
  const [portales, setPortales] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clinicaId) return;
    const q = query(collection(db, 'portales'), where('clinicaId', '==', clinicaId), orderBy('ultimaActualizacion', 'desc'));
    const unsub = onSnapshot(q, snap => { setPortales(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); });
    return unsub;
  }, [clinicaId]);

  const ahora = new Date();

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <Header titulo="Portal Paciente" backLabel="Dashboard" backRuta="/dashboard" />
      <div style={{ padding: '24px', background: theme.bg }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '10px', marginBottom: '20px' }}>
          {[
            { label: 'Portales activos', valor: portales.filter(p => { const v = p.vencimiento?.toDate ? p.vencimiento.toDate() : new Date(p.vencimiento); return v > ahora; }).length, color: theme.success, bg: theme.successBg },
            { label: 'Vencidos', valor: portales.filter(p => { const v = p.vencimiento?.toDate ? p.vencimiento.toDate() : new Date(p.vencimiento); return v <= ahora; }).length, color: theme.secondary, bg: theme.bgCard },
            { label: 'Total generados', valor: portales.length, color: theme.accent, bg: theme.infoBg },
          ].map(item => (
            <div key={item.label} style={{ background: item.bg, padding: '12px 14px', borderRadius: '10px' }}>
              <div style={{ fontSize: '11px', color: item.color, marginBottom: '4px', fontWeight: '500' }}>{item.label}</div>
              <div style={{ fontSize: '24px', fontWeight: '700', color: item.color }}>{item.valor}</div>
            </div>
          ))}
        </div>

        {loading
          ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px' }}>Cargando...</div>
          : portales.length === 0
            ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px', fontSize: '13px' }}>No hay portales generados aún</div>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {portales.map(p => {
                  const venc = p.vencimiento?.toDate ? p.vencimiento.toDate() : new Date(p.vencimiento);
                  const activo = venc > ahora;
                  const link = `${window.location.origin}/portal?token=${p.token}`;
                  return (
                    <div key={p.id} style={{ background: theme.bgCard, borderRadius: '10px', padding: '14px 18px', border: `0.5px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                      <div>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: theme.primary }}>{p.nombre}</div>
                        <div style={{ fontSize: '12px', color: theme.secondary }}>DNI {p.dni} · Vence {venc.toLocaleDateString('es-AR')}</div>
                      </div>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '99px', background: activo ? theme.successBg : theme.bgCard, color: activo ? theme.success : theme.secondary, fontWeight: '500', border: activo ? 'none' : `0.5px solid ${theme.border}` }}>
                          {activo ? 'Activo' : 'Vencido'}
                        </span>
                        {activo && (
                          <button onClick={() => { navigator.clipboard.writeText(link); alert('Link copiado al portapapeles'); }} style={{ fontSize: '11px', padding: '4px 10px', borderRadius: '6px', background: theme.infoBg, color: theme.accent, border: 'none', cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", fontWeight: '600' }}>
                            Copiar link
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
        }
      </div>
    </div>
  );
}